export const AllowedInterviewFormFields = [
	'candidateApplicationId',
	'interviewType',
	'startDate',
	'information',
	'recordInterview',
	'sendCandidateSmsReminder',
	'guests',
];
